module.exports = __webpack_public_path__ + "images/rankingEvents-has-rank-ff1a01e1.svg";